export const buildDroneEquipamentoHref = (droneId) => {
  if (droneId == null || droneId === '') return null;
  return `/v2/equipamentos?equipamentoId=${encodeURIComponent(droneId)}`;
};
